import React from "react";
var __jsx = React.createElement;
import AmwalForm from '../components/AmwalForm';
var AmwalFormPage = function AmwalFormPage() {
  return /*#__PURE__*/React.createElement(AmwalForm, null);
};
export default AmwalFormPage;